<mat-card>
  <mat-card-header class="header">
    <mat-card-title> Plate Location For {{ plate.plate }} </mat-card-title>
    <mat-card-subtitle>
      Captured At: {{ plate.eventTimeStamp | date : 'medium' }}
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="border">
    <div class="radar-map">
      <sn-google-map zoom="16" [center]="plateLocation" (mapInit)="onMapInit($event)">
        <div class="map__control-group">
          <div class="map__zoom zoomControl">
            <sn-icon-button (click)="zoomIn()" matTooltip="Zoom In" matTooltipPosition="left">
              <sn-icon fontSet="fal" fontIcon="fa-plus"></sn-icon>
            </sn-icon-button>
            <sn-icon-button (click)="zoomOut()" matTooltip="Zoom Out" matTooltipPosition="left">
              <sn-icon fontSet="fal" fontIcon="fa-minus"></sn-icon>
            </sn-icon-button>
          </div>
        </div>
      </sn-google-map>
    </div>
    <div class="cardResults">
      <ng-container [ngSwitch]="true">
        <ng-container *ngSwitchCase="isLprQueryModel(plate)">
          <fs-query-plate-card
            [onMap]="true"
            [plate]="plate"
            class="queryCard"
          ></fs-query-plate-card>
        </ng-container>
        <ng-container *ngSwitchCase="isFlockResult(plate)">
          <fs-flock-query-plate-card [onMap]="true" [plate]="plate" class="queryCard">
          </fs-flock-query-plate-card>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <fs-query-plate-card [plate]="plate" class="queryCard"> </fs-query-plate-card>
        </ng-container>
      </ng-container>
    </div>
  </mat-card-content>
</mat-card>
